var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWait(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M426.667 102.99V58.066C439.358 50.667 448 37.059 448 21.333V10.667A10.66 10.66 0 0 0 437.333 0H74.667A10.66 10.66 0 0 0 64 10.667v10.667c0 15.725 8.642 29.333 21.333 36.733v44.923c0 42.271 18.021 82.729 49.438 111L181.448 256l-46.677 42.01c-31.417 28.271-49.438 68.729-49.438 111v44.923C72.642 461.333 64 474.941 64 490.667v10.667A10.66 10.66 0 0 0 74.667 512h362.667a10.66 10.66 0 0 0 10.667-10.667v-10.667c0-15.725-8.642-29.333-21.333-36.733V409.01c0-42.271-18.021-82.729-49.438-111L330.552 256l46.677-42.01c31.417-28.271 49.438-68.73 49.438-111zm-77.979 79.291-64.292 57.865c-4.5 4.042-7.063 9.802-7.063 15.854s2.563 11.813 7.063 15.854l64.292 57.865C371.125 349.917 384 378.823 384 409.01V448h-26.672l-92.797-123.729c-4.021-5.375-13.042-5.375-17.063 0L154.672 448H128v-38.99c0-30.188 12.875-59.094 35.313-79.292l64.292-57.865c4.5-4.042 7.063-9.802 7.063-15.854s-2.563-11.813-7.063-15.854l-64.292-57.865C140.875 162.083 128 133.177 128 102.99V64h256v38.99c0 30.187-12.875 59.093-35.312 79.291z",
    fill: "#2491bc",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.521 149.333H182.469c-4.219 0-8.042 2.49-9.75 6.344a10.655 10.655 0 0 0 1.854 11.49l74.271 68.521c2.031 1.844 4.594 2.76 7.156 2.76s5.125-.917 7.156-2.76l74.26-68.521a10.654 10.654 0 0 0 1.854-11.49 10.665 10.665 0 0 0-9.749-6.344z",
    fill: "#2491bc",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWait);
export default __webpack_public_path__ + "static/media/wait.06af06b0ef4d92345cc5519cbdfb126a.svg";
export { ForwardRef as ReactComponent };